const fetchReferralStatus = async () => {
  function getCookie(name) {
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    for (const c of cookies) {
      const [key, ...v] = c.split("=");
      if (key === name) return decodeURIComponent(v.join("="));
    }
    return null; // not found
  }

  const affiliateId = getCookie("up_uppromote_aid");
  if (!affiliateId) {
    window.dispatchEvent(
      new CustomEvent("fetchReferralStatus", {
        detail: {
          hasReferral: false,
        },
      }),
    );
    return;
  }

  try {
    const response = await fetch(
      `https://api.halm.club/api/v2/shopify/referral-status?affiliateId=${affiliateId}`,
    );
    const data = await response.json();
    window.dispatchEvent(
      new CustomEvent("fetchReferralStatus", {
        detail: {
          hasReferral: data.status === "REFERRAL_ACTIVE",
        },
      }),
    );
  } catch (error) {
    console.error(error);
    window.dispatchEvent(
      new CustomEvent("fetchReferralStatus", {
        detail: {
          hasReferral: false,
        },
      }),
    );
  }
};

fetchReferralStatus();
